/*
 * OBS Login Redirect
 * ------------------
 * Sends customers back to the page they were on before logging in,
 * regardless of where Shopify lands them after successful login
 * (/account, /products, /collections/all, etc.).
 *
 * Strategy:
 *   1. Click on a Login/Register link  → store current URL in sessionStorage.
 *   2. Submit the login form           → set a "just logged in" flag.
 *   3. On the NEXT non-login page load → if both keys are set, redirect to
 *      the stored URL and clear the keys.
 */
(function () {
  'use strict';

  var STORAGE_RETURN = 'obs_return_to';
  var STORAGE_LOGIN  = 'obs_logging_in';
  var path = window.location.pathname;
  var DEBUG = false; // flip to true in browser console: localStorage.setItem('obs_debug','1')
  try { if (localStorage.getItem('obs_debug') === '1') DEBUG = true; } catch (e) {}
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[obs-login]'].concat([].slice.call(arguments))); }

  function isAccountPath(p) {
    return /^\/account(\/|$)/.test(p);
  }
  function isLoginPath(p) {
    return /^\/account\/(login|register)(\/|$)/.test(p);
  }
  // Shopify itself returns the customer to checkout (or any return_url) after
  // login. If it is doing that, this script MUST NOT interfere.
  function shopifyHandlesReturn() {
    try {
      var q = new URLSearchParams(window.location.search);
      return q.has('checkout_url') || q.has('return_url') || q.has('return_to');
    } catch (e) { return false; }
  }
  function isCheckoutPath(p) {
    return /^\/(checkouts?|checkout)(\/|$)/.test(p) || /^\/\d+\/checkouts\//.test(p);
  }
  function safeStore(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }
  function safeRead(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  // --- 1. Capture clicks on any login/register anchor ---------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var url;
    try { url = new URL(href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (isLoginPath(url.pathname) && !isAccountPath(path)) {
      var current = window.location.pathname + window.location.search + window.location.hash;
      safeStore(STORAGE_RETURN, current);
      log('captured pre-login URL:', current);
    }
  }, true);

  // --- 2. On the login page ----------------------------------------------
  if (isLoginPath(path) && shopifyHandlesReturn()) {
    // CHECKOUT FIX (2026-09-14): clicking Checkout while logged out sends the
    // customer to /account/login?checkout_url=/checkouts/cn/... . We used to
    // capture "/cart" here and then, right after login, replace() the customer
    // back to /cart — pulling them OUT of the checkout Shopify was sending
    // them to. Customers reported checkout "going blank". Stand down and let
    // Shopify's own return flow run.
    safeRemove(STORAGE_RETURN);
    safeRemove(STORAGE_LOGIN);
    return;
  }

  if (isLoginPath(path)) {
    // Referrer fallback: if user got here without a captured URL, use referrer
    if (!safeRead(STORAGE_RETURN) && document.referrer) {
      try {
        var ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && !isAccountPath(ref.pathname)) {
          var fallback = ref.pathname + ref.search + ref.hash;
          safeStore(STORAGE_RETURN, fallback);
          log('referrer fallback captured:', fallback);
        }
      } catch (err) {}
    }

    // When ANY form on the login page submits, flag "logging in"
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      // Only set on customer login forms. Shopify form id is typically "customer_login"
      // and action contains "/account/login". Be permissive.
      var action = (form.getAttribute('action') || '').toLowerCase();
      var formId = (form.getAttribute('id') || '').toLowerCase();
      if (action.indexOf('login') !== -1 || formId.indexOf('customer_login') !== -1) {
        safeStore(STORAGE_LOGIN, '1');
        log('login form submitted; flag set');
      }
    }, true);
  }

  // --- 3. On any non-login page, perform redirect if flag is set ----------
  if (isCheckoutPath(path)) {
    // Never redirect away from checkout; drop any stale flags.
    safeRemove(STORAGE_LOGIN);
    safeRemove(STORAGE_RETURN);
    return;
  }

  if (!isLoginPath(path)) {
    var loggingIn = safeRead(STORAGE_LOGIN);
    var returnTo  = safeRead(STORAGE_RETURN);
    log('page load:', path, 'loggingIn:', loggingIn, 'returnTo:', returnTo);
    if (loggingIn === '1' && returnTo) {
      safeRemove(STORAGE_LOGIN);
      safeRemove(STORAGE_RETURN);
      // Only redirect if it's a safe same-origin path
      if (returnTo.charAt(0) === '/' && returnTo.charAt(1) !== '/' && returnTo !== path) {
        log('redirecting back to:', returnTo);
        window.location.replace(returnTo);
      }
    }
  }
})();
